import React, {Fragment, useEffect, useState} from 'react'
import {Dialog, Disclosure, Menu, Transition} from '@headlessui/react'
import {Bars3Icon, BellIcon, UsersIcon, XMarkIcon} from '@heroicons/react/24/outline'

import Facelist from "./facelist.component";
import SidebarNavigation from "../../components/common/sidebarnavigation.component";
import {useLoaderData, useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {
    addEventAttribute,
    adminEventCard,
    audienceButtons,
    imagePad,
    isUrlValid,
    manageAttractionData,
    MetaTags,
    setDefaultPerformer, setDefaultVenue,
    setUniqueEventAttribute,
    setUniqueFaceAttribute,
    smallEventCard,
    smallSchemaArtistCard,
    thumbnailPad,
    toastSuccess
} from "../../components/common/utilities";
import {ChevronDownIcon, MagnifyingGlassIcon} from "@heroicons/react/20/solid";
import {ArrowLongLeftIcon, ArrowLongRightIcon, ChevronDoubleLeftIcon} from "@heroicons/react/16/solid";
import CreateFace from "../authentication/createFace";

import { useTranslation } from 'react-i18next';
import ArtistSources from "../attractions/sourcesArtist";
import EditDescriptions from "../../components/common/editdescriptions";
import MediaCollection from "../media/mediaCollection";
import Searchsidebar from "../../components/search/searchsidebar";
import FacePaymentInfo from "../authentication/facePaymentInfo";
import {ToastContainer} from "react-toastify";
import EditRequest from "../authentication/canEdit";

function classNames(...classes: any[])
{
    return classes.filter(Boolean).join(' ')
}

export default function UserDashboard() {
    const navigate = useNavigate();
    const logout = () => {
        window.location.href = '/logout';
    }

    let params = useParams();
    const venueID = params.venueID;
    const data = useLoaderData() as any;
    //console.log(data);

    const { t, i18n }:any = useTranslation('manageuser');
    const [events, setEvents] = useState([]);
    const [artistEvents, setArtistEvents] = useState([]);
    const [edp, setEDP] = useState([]);
    const [eventOffset, setEventOffset] = useState(0);
    const [eventLimit, setEventLimit] = useState(10);
    const [nextOffset, setNextOffset] = useState("");
    const [previousOffset, setPreviousOffset] = useState("");
    const [open, setOpen] = useState(false);
    const [teamList, setTeamList] = useState<any[]>([])
	const [owner, setOwner] = useState<any>([])
    const [inviteList, setInviteList] = useState<any[]>([])

    let [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState(null);
    const [statusMessage, setStatusMessage] = useState(null);
    const [detailStatusMessage, setDetailStatusMessage] = useState(null);
    const [showTeam, setShowTeam] = useState(false);
    const [showCreateFace, setShowCreateFace] = useState(false);
    const [getStarted,setGetStarted] = useState(false);
    const [showMediaSelector, setShowMediaSelector] = useState(false);
    const [workingWith, setWorkingWith] = useState<SchemaArtist>();
    const [showConnector, setShowConnector] = useState(true);
    const [showPaymentInfo, setShowPaymentInfo] = useState(false);
    const [showEditRequest, setShowEditRequest] = useState(false);


    const switchLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
    };

    type SchemaArtist = {
        [key: string]: any; // ?? variable key
        name: string;
    };
    const [artistData, setArtistData] = useState<SchemaArtist>();

    var date = new Date();

    function inviteMember(e)
    {
        e.currentTarget.disabled = true;
        e.preventDefault();
        const query = e.target.email.value;
        console.log('inviting member ', query);
        setLoading(true);
        setStatusMessage(null);
        setSuccessMessage(null);
        setDetailStatusMessage(null);
        axios.post(`${process.env.REACT_APP_API_URL}/p/user/sendinvite.do`, {
            guid: data.guid, ticket: localStorage.getItem('ticket'), email: query,
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }
                   })
            .then(function (response) {
                // handle success
                //console.log(response);
                let location = response.data;
                console.log(location);
                setLoading(false);
                setSuccessMessage('Invitation sent to ' + query);

            })
            .catch(function (error) {
                setLoading(false);
                console.log(error);

                setStatusMessage(error.message)
                setDetailStatusMessage(error.response.data.error)
            });


    }

    const getTeam = () => {
        window.scrollTo(0, 0);
        //setEvents([]);


        axios.post(`${process.env.REACT_APP_API_URL}/p/user/teamlist.do`, {
            ticket: localStorage.getItem('ticket'), guid: data.guid
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }
                   })
            .then(function (response) {
                // handle success
                //console.log(response);
                let location = response.data;
                console.log(location);
                setTeamList(response.data.users);
				setOwner(response.data.owner);
				console.log(response.data.owner);

            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const getInvited = () => {
        //window.scrollTo(0, 0);
        //setEvents([]);


        axios.post(`${process.env.REACT_APP_API_URL}/p/user/invitelist.do`, {
            ticket: localStorage.getItem('ticket'), guid: data.guid
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }
                   })
            .then(function (response) {
                // handle success
                //console.log(response);
                let location = response.data;
                console.log(location);
                setInviteList(response.data);

            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const changeFace = (guid) => {


        axios.post(`${process.env.REACT_APP_API_URL}/p/user/changeface.do`, {
            ticket: localStorage.getItem('ticket'), guid: guid
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }
                   })
            .then(function (response) {
                // handle success
                console.log(response);
                if (response.data.name)
                {
                    localStorage.setItem('username', response.data.name);
                    window.location.href = '/manage/user';
                }


            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const [faces, setFaces] = useState<any[]>([]);

    function getBestImage(property: any)
    {
        let attr = property.attributes;
        let bestPicture = '';
        if (attr && attr.length > 0)
        {
            for (let i = 0; i < attr.length; i++)
            {
                if (attr[i].key === 'bestPicture')
                {
                    bestPicture = attr[i].value;
                    break
                }
            }
        }
        return bestPicture;
    }

    function getPicture(property: any)
    {
        let attr = property.attributes;
        let bestPicture = '';
        if (attr && attr.length > 0)
        {
            for (let i = 0; i < attr.length; i++)
            {
                if (attr[i].key === 'picture')
                {
                    bestPicture = attr[i].value;
                    break
                }
            }
        }
        return bestPicture;
    }

    function getArtistOrVenue(property: any)
    {
        let attr = property.attributes;
        let bestPicture = '';
        if (attr && attr.length > 0)
        {
            for (let i = 0; i < attr.length; i++)
            {
                if (attr[i].key === 'promo.custom.artistid')
                {
                    bestPicture = attr[i].value;
                    break
                }
                if (attr[i].key === 'promo.custom.venueid')
                {
                    bestPicture = attr[i].value;
                    break
                }
            }
        }
        return bestPicture;
    }

    const getFaces = nextOffset => {
        window.scrollTo(0, 0);

        axios.post(`${process.env.REACT_APP_API_URL}/p/api/gogo/facelist.do`, {
            ticket: localStorage.getItem('ticket'),
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }
                   }).then(function (response) {
            // handle success
            console.log("events", response);
            if(response.data && response.data.length == 1)
            {
                setGetStarted(true);
            }

            setFaces(response.data);
        }).catch(function (error) {
            console.log(error);
        });
    }


    useEffect(() => {
        i18n.changeLanguage(navigator.language.split('-')[0]);
        if(data.performer || data.venue)
        {
            setShowConnector(false);
        }

        getFaces(null);

    }, []);

    const closeModal = () => {
        setOpen(false);
        setShowTeam(false);
        setShowCreateFace(false);
        setSuccessMessage(null);
        setStatusMessage(null);
        setDetailStatusMessage(null);
    }

    const toggleTeam = (shouldShow) => {
        setShowTeam(shouldShow);
        if (shouldShow)
        {
            getTeam();
            getInvited();
            setOpen(true);
        }
    }

    const toggleCreate = (shouldShow) => {
        setShowCreateFace(true)
        setOpen(true);
    }

    const showMedia = () => {
        setShowMediaSelector(true);
        setOpen(true);
    }

    const handleImageURL = e => {
        var imageurl = e.target.value;
        if (imageurl.length > 4 && !isUrlValid(imageurl))
        {
            toastSuccess("URL is invalid");

            return;
        }
        console.log('handle imageurl: ', e.target.value);
        let key = "bestPicture";
        let value = imageurl;
        let unique = true;
        let remove = false;
        let artistid = params.id;

        setUniqueFaceAttribute(key, value, "setUnique");


        //console.log(text.current);
        //setAttribute(data['guid'], e.target.id, document.getElementById(e.target.id).textContent, true, false);
    };

    const reload = () => {
        window.location.reload()
    }

    function clickedEvent(e)
    {
        console.log("clicked", e.target);

        let button = e.target.dataset.button;
        if (button === 'setAd')
        {
            console.log('setAd');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            toastSuccess('Event updated');

        }
        else if (button === 'setPrivate')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            toastSuccess('Event set to private');

        }
        else if (button === 'viewEvent')
        {
            let eventid = e.target.dataset.eventid;
            /*
                        viewArtist(null,eventid);
            */
        }
        else if (button === 'setAttractionType')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            toastSuccess('Attraction Type set to ' + value);

        }

        else if (button === 'addAttribute')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = false;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            addEventAttribute(key, value, unique, eventid);

            toastSuccess('Attribute ' + key + ' set to ' + value);

        }

        else if (button === 'manageAudience')
        {
            console.log('managing audience');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = false;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            addEventAttribute('pgg.audience.' + key, 'pgg.audience.' + value, remove, eventid);

            toastSuccess('Audience set ' + key + ' Remove: ' + remove);

        }

        else if (button === 'face')
        {
            let newguid = e.target.dataset.guid;
            console.log('changing face to ', newguid);

            changeFace(newguid);

        }

        else if(button === 'setFaceImage')
        {
            let key = e.target.dataset.key;
            let value = e.target.dataset.media;
            setUniqueFaceAttribute("bestPicture", value, "setUnique");
        }

        else if(button === 'workingWith')
        {
            let key = e.target.dataset.key;
            let value = e.target.dataset.media;
            let image = e.target.dataset.imageurl;
            if(image)
            {
                setUniqueFaceAttribute("bestPicture", image, "setUnique");
            }
            let artistid = e.target.dataset.artistid;
            let venueid = e.target.dataset.venueid;

            if(artistid)
            {
                setUniqueFaceAttribute("promo.custom.artistid", artistid, "setUnique");
            }
            if(venueid)
            {
                setUniqueFaceAttribute("promo.custom.venueid", venueid, "setUnique");
            }
            if(artistid)
            {
                axios.get(`${process.env.REACT_APP_API_URL}/p/api/artist.do`, {
                    params: {
                        lang: "is",
                        artist: artistid
                    }
                }).then(function (response) {
                    // handle success
                    setDefaultPerformer(response.data);
                    localStorage.removeItem('defaultVenue');
                    setEvents([]);
                    console.log("artist", response);
                    setWorkingWith(response.data);
                });
            }
            else if(venueid)
            {
                axios.get(`${process.env.REACT_APP_API_URL}/p/api/venue.do`, {
                    params: {
                        lang: "is",
                        venue: venueid,
                        light: true,
                    }
                }).then(function (response) {
                    // handle success
                    localStorage.removeItem('defaultPerformer');

                    setDefaultVenue(response.data);
                    setEvents([]);
                    console.log("venue", response);
                    setWorkingWith(response.data);
                });

            }
            setTimeout(() => reload(), 2000);


        }




    }

    const toggleTabs = (which) => {
        setShowEditRequest(false);
        setShowPaymentInfo(false);
        setShowConnector(false);
        if(which == "edit")
        {
            setShowEditRequest(true);
        }
        if(which == "payment")
        {
            setShowPaymentInfo(true);
        }
        if(which == "connector")
        {
            setShowConnector(true);
        }
    }


    return (<>
        <MetaTags
            title='User Dashboard'
            description='Auðveldaðu menningarumfjöllunina'
            image='https://promogogo.com/cdn-cgi/image/fit=contain,width=768/https://media.promogogo.com/ymsirvidburdir/2024-06-10/3666078aaa094262b626960bf705498b.png'
            name='Team Mobilitus'
        />
        <div className="min-h-full dark:bg-white bg-white">
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-40" onClose={closeModal}>
                    <div className="fixed inset-0"/>

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-2">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                                        <div
                                            className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
                                            <div
                                                className="flex min-h-0 flex-1 flex-col overflow-y-scroll overflow-x-hidden py-1">

                                                <div className="relative mt-6 flex-1 px-4 sm:px-6">
                                                    {showTeam && <>
                                                    <div className="mt-2">

                                                        <h4 className={'text-lg font-semibold text-gray-900'}>Team
                                                            Members for {data.name}</h4>
														{owner && <div className={'text-sm text-gray-700'}>Owner: {owner.firstName} {owner.loginName}</div>}
                                                        {teamList.length > 0 && teamList.map((team) => (<div
                                                            className="bg-white shadow overflow-hidden sm:rounded-md mb-4"
                                                            key={'team' + team.userGUID}>
                                                            <div
                                                                className="px-4 py-5 sm:px-6 flex justify-between items-center">
                                                                <div className="flex items-center">
                                                                    <div className="ml-4">
                                                                        <div
                                                                            className="text-sm font-semibold text-gray-900">{team.firstName} {team.lastName}</div>
                                                                        <div
                                                                            className="text-sm text-gray-500">{team.loginName}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="ml-5 flex-shrink-0">
                                                                    <button
                                                                        onClick={() => navigate('/dashboard/venue/' + team.userGUID)}
                                                                        className="font-semibold text-gray-900 hover:text-gray-700"
                                                                    >
                                                                        View
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>))}
                                                        <h4 className={'text-lg font-semibold text-gray-900'}>Invited
                                                            to {data.name}</h4>
                                                        {inviteList.length > 0 && inviteList.map((team) => (<div
                                                            className="bg-white shadow overflow-hidden sm:rounded-md mb-4"
                                                            key={'team' + team.userGUID}>
                                                            <div
                                                                className="px-4 py-5 sm:px-6 flex justify-between items-center">
                                                                <div className="flex items-center">
                                                                    <div className="ml-4">
                                                                        <div
                                                                            className="text-sm font-semibold text-gray-900">{team.firstName} {team.lastName}</div>
                                                                        <div
                                                                            className="text-sm text-gray-500">{team.loginName}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="ml-5 flex-shrink-0">
                                                                    <button
                                                                        onClick={() => navigate('/dashboard/venue/' + team.userGUID)}
                                                                        className="font-semibold text-gray-900 hover:text-gray-700"
                                                                    >
                                                                        View
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>))}



                                                    </div>

                                                        <div className="mt-2">
                                                        <h4 className={'text-lg font-semibold text-gray-900'}>Invite
                                                            someone to manage {data.name}</h4>

                                                        <div className="mt-2">
                                                            <form onSubmit={inviteMember}>
                                                                <div>
                                                                    <label htmlFor="email"
                                                                           className="block text-sm font-medium leading-6 text-gray-900">
                                                                        Enter email address
                                                                    </label>
                                                                    <div className="mt-2 flex rounded-md shadow-sm">
                                                                        <div
                                                                            className="relative flex flex-grow items-stretch focus-within:z-10">
                                                                            <div
                                                                                className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                                                                <UsersIcon
                                                                                    className="h-5 w-5 text-gray-400"
                                                                                    aria-hidden="true"/>
                                                                            </div>
                                                                            <input
                                                                                type="email"
                                                                                name="email"
                                                                                id="email"
                                                                                className="block w-full rounded-none rounded-l-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                                                placeholder="Email address"
                                                                            />
                                                                        </div>
                                                                        <button
                                                                            type="submit"
                                                                            className="relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                                                        >
                                                                            Invite
                                                                        </button>
                                                                    </div>
                                                                    {successMessage && (

                                                                        <div className="text-center text-green-500 p-1">
													<span
                                                        className="text-center text-green-500 p-1">{successMessage}</span>
                                                                        </div>)}
                                                                    {!statusMessage && (
                                                                        <div className="text-center text-red-500 p-1">
                                                                            {statusMessage && <span
                                                                                    className="text-center text-red-500 p-1">{statusMessage}</span>}
                                                                            {detailStatusMessage && <span
                                                                                    className="text-center text-red-500 p-1"><br/>{detailStatusMessage}</span>}
                                                                        </div>)}
                                                                </div>
                                                            </form>
                                                        </div>


                                                    </div></>}
                                                    {showCreateFace && <CreateFace/>}

                                                    <div className="relative mt-6 flex-1 px-4 sm:px-6"
                                                         onClick={event => clickedEvent(event)}>
                                                        {showMediaSelector &&
                                                         <MediaCollection wide={true} target={'setFaceImage'}/>}

                                                    </div>

                                                </div>
                                            </div>
                                            <div className="flex flex-shrink-0 justify-end px-4 py-4">
                                                <button
                                                    type="button"
                                                    className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
                                                    onClick={() => closeModal()}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
            <SidebarNavigation/>
            <div className="lg:pl-72">
              <div className={'md:grid md:grid-cols-3'}>
                    <div className={'col-span-2'}>
                        {getStarted && <div className={'mt-2'}>

                            <div className="mx-auto max-w-7xl px-6 py-6 sm:py-6 lg:px-8">
                                <div className={'gap-4'}>
                                    <div className={''}>
                                        <h2 className="text-3xl font-bold tracking-tight text-pg_blue sm:text-4xl">
                                            {t('letsgetstarted')}, {data.userName}
                                        </h2>
                                        <div className="mt-10 flex items-center gap-x-6">
                                            <div className=" leading-6 text-gray-900">
                                                {t('startingout')}
                                            </div>

                                        </div>
                                        <CreateFace/>


                                    </div>

                                </div>
                            </div>

                        </div>}


                        {!getStarted && data.mask === 'person' && <div className="mx-auto max-w-7xl px-6 py-6 sm:py-6 lg:px-8">
                            <div className={'gap-4'}>
                                <div className={''}>
                                    <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                                        {t('thisisyourprivateaccount')}
                                    </h2>
                                    <div className="mt-10 flex items-center gap-x-6">
                                        <div className=" font-semibold leading-6 text-gray-900">
                                            {t('youllneedto')}
                                        </div>

                                    </div>
                                    <CreateFace/>


                                </div>

                            </div>
                        </div>}
                        {!getStarted && data.mask !== 'person' && <div className="p-2">
                            <div className="mx-auto max-w-7xl px-6 py-6 sm:py-6 lg:px-8">
                                <div className={'gap-4'}>
                                    <div className={''}>

                                        <h2 className="mt-4 p-2 text-sm tracking-tight text-pg_blue text-xl">{t('hello')}, {data.userName}</h2>

                                        <div className="mt-3 flex items-center gap-x-6">
                                            <div className=" font-semibold leading-6 text-gray-900">
                                                {t('youcanhaveaccess')}
                                            </div>
                                            <button className={'w-1/5 rounded-md bg-pg_green px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400'} onClick={() => toggleCreate(!showCreateFace)}>{t('createbutton')}</button>

                                        </div>


                                    </div>

                                </div>
                            </div>

                            <div className={'grid grid-cols-4 mt-2 mb-2 p-2'}>
                                <div className={'col-span-1'} onClick={() => showMedia()}>
                                    {data.picture && thumbnailPad(data.picture)}
                                    {!data.picture &&
                                     <div className="text-sm flex flex-col justify-end bg-gray-200 h-28 cursor-pointer"><span className={'text-center pb-1'}>Upload Image</span></div>}
                                </div>
                                <div className={'col-span-3 pl-2'}>
                                    <div className={'text-sm text-gray-500'}>{t('currentsite')}: </div>
                                    <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{data.name}</h2>
                                    <div className={'mt-2'}>
{/*
                                    <button className={'rounded-md bg-pg_green px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400'} onClick={() => toggleTeam(!showTeam)}>{t('whohasaccess')}</button>
*/}
                                        <button className={'rounded-md bg-pg_green px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400'} onClick={() => toggleTabs('connector')}><i className="fa-regular fa-link"></i> {t('showconnector')}</button>
                                        <button className={'rounded-md bg-pg_green px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400'} onClick={() => toggleTabs('payment')}><i className="fa-regular fa-money-check-pen"></i> {t('showpaymentinfo')}</button>
                                        <button className={'rounded-md bg-pg_green px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400'} onClick={() => toggleTabs('edit')}><i className="fa-regular fa-lock-open"></i> {t('showeditrequest')}</button>

                                    </div>
                                </div>

                            </div>
                            {showConnector && <>
                                <h3 className={'text-lg text-pg_blue text-center'}>{t('showconnectorinfo')}</h3>
                                <p className={' text-gray-700 p-2'}>{t('showconnectorinfodetail')}</p>
                                <div onClick={(event) => clickedEvent(event)}>
                                    <Searchsidebar buttontype={'workingWith'} initialQuery={data.name}/>
                                </div>
                            </>}

                            {data.isAdmin &&
                            <div>
                                <input type={'url'}
                                       className={'block w-full rounded-none border-0 py-1.5 pl-2 ring-1 ring-inset ring-gray-300  focus:ring-2 focus:ring-inset focus:ring-indigo-600  tracking-tight text-gray-900'}
                                       onBlur={handleImageURL}
                                       defaultValue={data.picture}
                                />
                            </div>}

                            {showPaymentInfo && <FacePaymentInfo/>}
                            {showEditRequest && <EditRequest params={data} eventid={null} artistid={data.performer} venueid={data.venue}/>}
                        </div>}
                    </div>
                    <div className={'md:col-span-1'}>
                        <div className="p-1" onClick={(event) => clickedEvent(event)}>
                            {faces && faces.length > 1 && <div className="text-center text-pg_blue mt-2">{t('youraccounts')}</div>}
                            <div role="list" className="mt-2">
                                {faces && faces.map((face) => <div key={face.guid} className="col-span-1 overflow-hidden bg-white shadow sm:rounded-lg mt-2" data-button={'face'} data-guid={face.guid}>
                                    <div className="w-full relative rounded-xl shadow-lg p-4 bg-white" data-button={'face'} data-guid={face.guid}>
                                        <button data-button={'face'} data-guid={face.guid}
                                            className="absolute inset-0 z-10 bg-transparent"
                                            aria-label="Click card"
                                        />
                                        <div className={'flex relative z-0'}>
                                        <div className="flex-1 truncate" aria-hidden="true">

                                            <div className="flex items-center space-x-3">
                                                <h3 className="truncate text-sm font-medium text-gray-900" >{face.name}</h3>
                                            </div>
                                            <div><span
                                                className="inline-flex flex-shrink-0 items-center rounded-full bg-green-50 px-1.5 py-0.5 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                  {face.mask}
                </span></div>

                                        </div>
                                        <div>
                                            {getBestImage(face) && (<div><img className="h-16 w-16 flex-shrink-0 rounded bg-gray-300"
                                                                              src={'https://promogogo.com/cdn-cgi/image/width=230,height=230,fit=pad/' + getBestImage(face)}
                                                                              alt=""/></div>)}
                                            {!getBestImage(face) && getPicture(face) && (
                                                <div><img className="h-16 w-16 flex-shrink-0 rounded bg-gray-300"
                                                          src={'https://promogogo.com/cdn-cgi/image/width=230,height=230,fit=pad/' + getPicture(face)}
                                                          alt=""/></div>)}
                                            {!getBestImage(face) && !getPicture(face) && (
                                                <div><img className="h-16 w-16 flex-shrink-0 rounded bg-white"
                                                          src={'https://media.promogogo.com/ojqwiyls/radar-f15ed2e7-915a-4a7b-a098-ae3236576a0a-promo_icon_400x400px_circle.png'}
                                                          alt=""/></div>)}
                                        </div>
                                        </div>
                                    </div>
                                </div>)}
                            </div>

                        </div>
                    </div>
                </div>




            </div>
        </div>
        <ToastContainer autoClose={800} theme={'dark'}/>


    </>)
}
